import styled from 'styled-components'
import { palette, spacing } from '@conserveit/blocks'
import { Wrap } from '../Layout/Page'

export const StyledBackgroundRow = styled.div`
  background: #fff;
  border-bottom: 1px solid ${palette.neutral4};
`

export const StyledWrap = styled(Wrap)`
  display: flex;
  padding-top: ${spacing.extraLoose};
  padding-bottom: ${spacing.extraLoose};
`
